$(".matrix--data-table table").rtResponsiveTables({
  containerBreakPoint: 640
});
